import React from 'react';
import { WithTranslationProps } from 'Common/Components/Translation/WithTranslationProps';
import withTranslation from 'Common/withTranslation';

const LoadingButton: React.FC<WithTranslationProps> = ({
    t
}) => {
    return (
        <button className="btn btn-custom flex flex-row justify-center items-center gap-2 cursor-not-allowed" type='button' disabled>
            <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-t-2 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
                <span>{t("General.Loading")}...</span>
            </div>
        </button>
    );
};

export default withTranslation(LoadingButton);
